import { IconCircleX, IconSearch } from "@tabler/icons-react";
import { ChangeEvent } from "react";

import { createChangeEvent } from "../../utils/form";

export interface SearchInputProps {
  disabled?: boolean;
  name?: string;
  value?: string;
  placeholder?: string;
  onChange?: (event: ChangeEvent<HTMLInputElement>, value: string) => void;
  rounded?: boolean;
}

const outerStyle = `
  bg-bg-components-base hover:bg-bg-components-hover border-border-strong text-text-base
  focus:bg-bg-components-hover focus:outline-focus focus:outline-offset-1
  active:border-border-interactive-base active:outline-input-interactive active:outline-offset-0
`;

const innerStyle = `
  bg-transparent placeholder:text-text-subtle placeholder:disabled:text-text-disabled;
`;

const disabledStyle = `
  text-text-disabled bg-bg-disabled border-border-disabled cursor-not-allowed outline-0 outline-offset-0
`;

const SearchInput = ({
  disabled = false, name, value, placeholder, onChange, rounded = false,
}: SearchInputProps) => (
  <div className={`flex w-[300px] items-center gap-1 typography-medium-base border px-3 py-2.5
   ${disabled ? disabledStyle : outerStyle} 
   ${rounded ? "rounded-full" : "rounded-lg"}`}
  >
    <IconSearch className={disabled ? "text-icon-disabled" : "text-icon-bg-subtle"} />
    <input
      id={name}
      className={`w-full outline-0 border-0 ${disabled ? disabledStyle : innerStyle}`}
      disabled={disabled}
      placeholder={placeholder}
      value={value}
      onChange={(e) => {
        onChange(createChangeEvent(name, e.target.value), e.target.value);
      }}
    />
    {(value && !disabled) && (
      <IconCircleX
        className="text-icon-bg-subtle cursor-pointer"
        onClick={() => onChange(createChangeEvent(name, ""), "")}
      />
    )}
  </div>
);

export default SearchInput;
